import { createSelector } from '@reduxjs/toolkit'

import { getSecurity } from '../../root.selectors'

export const getSecurityGroups = createSelector(getSecurity, (security) => security.groups)
